import type { DecisionItem } from "../../contract"
import { DecisionRow } from "../../ds"
import { useAnswerSession } from "../session"
import { useBlockScope } from "./context"

/** Decisions that help or hurt the reader (Question-v4 03): the tilted glyph and the word head the group. */
export function Decisions({ lean, items, none }: { lean: "helps" | "hurts"; items: DecisionItem[]; none?: string }) {
  const { turn, sources } = useBlockScope()
  const openSource = useAnswerSession((s) => s.openSource)
  const binding = items.filter((i) => i.binds).length
  return (
    <DecisionRow.Group
      title={lean === "helps" ? "Helps you" : "Hurts you"}
      lean={lean}
      count={items.length || undefined}
      aside={binding ? `${binding} ${binding === 1 ? "binds" : "bind"} you` : undefined}
      className="adec"
    >
      {items.map((it) => {
        const src = sources[it.source_id]
        const name = src?.name || src?.label || "Decision"
        return (
          <div className="nr-decision" key={it.source_id}>
            <button
              type="button"
              className="nr-decision-name"
              onClick={(e) => openSource({ turn, id: it.source_id, from: e.currentTarget })}
            >
              {name}
            </button>
            <div className="nr-decision-court">{it.binds ? "binds you" : ""}</div>
            <div className="nr-decision-scope">{it.scope}</div>
            <div className="nr-decision-hold">{it.holding}</div>
          </div>
        )
      })}
      {!items.length ? <p className="adec-none">{none || "None found."}</p> : null}
    </DecisionRow.Group>
  )
}
